import React, { useState } from 'react';
import { Container, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';

const EmailVerify = () => {
  const [email, setEmail] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false); // New state for loading

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);  // Set loading to true when form is submitted
    try {
      const response = await fetch('https://apiaksharaconnect.aksharafinalytics.in/verificationlink', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        throw new Error(`Failed to register user: ${response.statusText}`);
      }

      const data = await response.json();
      console.log('API Response:', data); // Logging the response for debugging

      if (data.status === 'success') {
        setSuccessMessage('Change Password link sent. Check your email.');
        setEmail(''); // Reset the form input after success
      } else if (data.status === 'error') {
        setError(data.message || 'Error sending link. Please try again.');
      }
    } catch (error) {
      console.error('Error:', error); // Logging the error for debugging
      setError(error.message || 'Error sending link. Please try again.');
    } finally {
      setIsLoading(false); // Set loading to false once the response is received
    }
  };

  return (
    <Container className="mt-5">
      <div className="text-center mb-4">
        <img
          src="https://aksharafinalytics.com/wp-content/uploads/elementor/thumbs/akfin-qgepick2gc4b4m3xfynr658qlgki21rx8vyqzuu9ys.png"
          alt="Logo"
          style={{ maxWidth: '150px' }}
        />
      </div>

      {successMessage && <Alert variant="success" className="mb-2 text-center">{successMessage}</Alert>}
      {error && <Alert variant="danger">{error}</Alert>}

      {/* Show loader if isLoading is true */}
      {isLoading && (
        <div className="text-center mb-3">
          <Spinner animation="border" variant="primary" />
        </div>
      )}

      <Card className="shadow" style={{ maxWidth: '500px', margin: '0 auto' }}>
        <Card.Header>
          <h4>Email Verify</h4>
        </Card.Header>
        <Card.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="email" className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                value={email}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <div className="text-center">
              <Button type="submit" variant="primary" disabled={isLoading}> {/* Disable button when loading */}
                Submit
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default EmailVerify;
